<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.businessusers') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <b-button variant="primary" @click="$router.go(-1)">
                        <b-icon icon="arrow-left" class="icon-style"></b-icon>
                    </b-button>
                    <!--                    <b-button variant="primary" @click="$router.push({ name: 'savedMondaycrmLeads' })">-->
                    <!--                        <b-icon icon="bookmark" class="ms-2"></b-icon>-->
                    <!--                    </b-button>-->
                    <template #cell(action)="{ item }">
                        <input type="checkbox" :value="item.owner" v-model="selectedUsers" class="mr-2" />
                    </template>
                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'action', label: self.$t('title.action') },
    { key: 'object_id', label: self.$t('title.object_id'), sortable: true },
    { key: 'etag', label: self.$t('title.etag'), sortable: true },
    { key: 'integration_id', label: self.$t('title.integration'), sortable: true },
    { key: 'employee_id', label: self.$t('title.employee_id'), sortable: true },
    { key: 'employee_uuid', label: self.$t('title.employee_uuid'), sortable: true },
    { key: 'user_id', label: self.$t('title.user_id'), sortable: true },
    { key: 'technical_user_id', label: self.$t('title.technical_user_id'), sortable: true },
    { key: 'identity_uuid', label: self.$t('title.identity_uuid'), sortable: true },
    { key: 'business_partner_id', label: self.$t('title.business_partner'), sortable: true },
    { key: 'business_partner_formatted_name', label: self.$t('title.business_partner_name'), sortable: true },
    { key: 'department_name', label: self.$t('title.department_name'), sortable: true },
    { key: 'company_name', label: self.$t('title.company_name'), sortable: true },
    { key: 'manager_name', label: self.$t('title.manager_name'), sortable: true },
    { key: 'email_uri', label: self.$t('title.email_uri'), sortable: true },
    { key: 'decimal_format_code', label: self.$t('title.decimal_format_code'), sortable: true },
    { key: 'decimal_format_code_text', label: self.$t('title.decimal_format_code_text'), sortable: true },
    { key: 'date_format_code', label: self.$t('title.date_format_code'), sortable: true },
    { key: 'date_format_code_text', label: self.$t('title.date_format_code_text'), sortable: true },
    { key: 'time_format_code', label: self.$t('title.time_format_code'), sortable: true },
    { key: 'time_format_code_text', label: self.$t('title.time_format_code_text'), sortable: true },
    { key: 'time_zone_code', label: self.$t('title.time_zone_code'), sortable: true },
    { key: 'time_zone_code_text', label: self.$t('title.time_zone_code_text'), sortable: true },
    { key: 'logon_language_code', label: self.$t('title.logon_language_code'), sortable: true },
    { key: 'logon_language_code_text', label: self.$t('title.logon_language_code_text'), sortable: true },
    { key: 'user_validity_start_date', label: self.$t('title.user_validity_start_date'), sortable: true },
    { key: 'user_validity_end_date', label: self.$t('title.user_validity_end_date'), sortable: true },
    { key: 'user_locked_indicator', label: self.$t('title.user_locked_indicator'), sortable: true },
    { key: 'user_counted_indicator', label: self.$t('title.user_counted_indicator'), sortable: true },
    { key: 'password_policy_code', label: self.$t('title.password_policy_code'), sortable: true },
    { key: 'password_inactive_indicator', label: self.$t('title.password_inactive_indicator'), sortable: true },
    { key: 'password_locked_indicator', label: self.$t('title.password_locked_indicator'), sortable: true },
    { key: 'user_account_type_code', label: self.$t('title.user_account_type_code'), sortable: true },
    { key: 'user_account_type_code_text', label: self.$t('title.user_account_type_code_text'), sortable: true },
    { key: 'created_on', label: self.$t('title.created_on'), sortable: true },
    { key: 'user_created_by', label: self.$t('title.user_created_by'), sortable: true },
    { key: 'entity_last_changed_on', label: self.$t('title.entity_last_changed_on'), sortable: true },
    { key: 'user_changed_by', label: self.$t('title.user_changed_by'), sortable: true }
];

export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if (this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
    },
    computed: {
        listUrl() {
            return `admin/sap/business-users/${this.$route.params.id || ''}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
